














import { Vue, Component } from 'vue-property-decorator'
import { ItemAdv } from '../models'

@Component({
  components: {
  }
})

export default class ItemsAdv extends Vue {
  items: ItemAdv[] = [
    { descr: 'Управляйте бизнесом на&nbsp;любой платформе. Мы&nbsp;поддерживаем iOS, Android, а&nbsp;также имеем сайт.', img: '/static/images/cross.png',
      isActive: true, title: 'Кроссплатформенность'
    },
    {descr: 'Изменяйте и&nbsp;управляйте ценообразованием товаров в&nbsp;любое время.', img: '/static/images/price.png', title: 'Ценообразование'},
    {descr: 'Получайте и&nbsp;реагируйте на&nbsp;уведомления от&nbsp;ФНС мгновенно.', img: '/static/images/notif.png', title: 'Уведомления'},
    {descr: 'Создавайте электронные чеки в&nbsp;один клик. Сторнируйте их&nbsp;при необходимости.', img: '/static/images/receipts.png', title: 'Онлайн чеки'},
  ]
}
